import axios from 'axios';
import { CompareCars } from './compare-cars';

export default class searchCar {
  constructor(lazy) {
    this.lazy = lazy;
    this.search_form = document.querySelector('#search-car');
    this.loader = document.querySelector('[data-form-loader]');
    this.loader_active = false;
    this.current_type = false;
    this.current_model = false;
    this.current_page = false;
    this.compare_badge = document.querySelector('.js-compare-button');

    this.initialModelTitleEl = document.querySelector('[data-model-search-title]');
    this.initialTypeTitleEl = document.querySelector('[data-type-search-title]');
    this.initialModelTitle = this.initialModelTitleEl ? this.initialModelTitleEl.innerHTML : '';
    this.initialTypeTitle = this.initialTypeTitleEl ? this.initialTypeTitleEl.innerText : '';


    this.compare_cars = new CompareCars();
  }

  init() {
    if (!this.search_form) {
      return false;
    }

    this.addListeners();
    this.sendForm(false);
  }


  _toggleCompareBadge() {
    this.current_slots = this._getCarsCount();

    if (!this.compare_badge) {
      return false;
    }

    if (this.current_slots) {
      this._animateVisibility(this.compare_badge, true);
    } else {

    }
  }

  _animateVisibility(element, show) {
    if (show) {
      element.style.display = 'flex';
      element.style.opacity = '1';
    } else {

    }
  }

  _getCarsCount() {
    let current_data = JSON.parse(localStorage.getItem(this.localStorageKeyName));
    if (current_data === null || !current_data || !current_data.length) {
      return false;
    } else {
      return current_data.length;
    }
  }

  resetForm() {
    this.search_form.reset();

    let inputs = this.search_form.querySelectorAll('input');

    inputs.forEach((input) => {
      input.checked = false;
      input.parentElement.classList.remove('border-primary', 'text-grayscale-800', 'bg-grayscale-100');
      if (input.nextElementSibling) {
        let childrens = input.nextElementSibling.childNodes;

        if (childrens[1]) {
          childrens[1].classList.remove('bg-primary');
        }
      }
    });

    let selects = this.search_form.querySelectorAll('select');
    selects.forEach((select) => {
      select.value = '';
    });

    this.resetModelSelect();
    this.sendForm();
  }

  resetModelSelect() {
    const selectedItems = document.querySelectorAll('div.selected-item');
    if (!selectedItems.length) {
      return;
    }

    selectedItems.forEach((item) => {
      item.remove();
    });

    const modelSelect = document.querySelector('.select-js .control');
    if (!modelSelect) {
      return;
    }

    const noModelSelected = document.createElement('div');
    noModelSelected.classList.add('no-items-selected');
    noModelSelected.innerText = window.ajax_object.trans_select_model;
    modelSelect.appendChild(noModelSelected);
  }

  toggleLoader() {
    if (!this.loader) {
      return false;
    }

    if (this.loader_active) {
      this.loader.style.cssText = '';
      this.loader.style.display = 'none';
    } else {
      this.loader.style.display = 'flex';
    }

    this.loader_active = !this.loader_active;
  }

  addListeners() {
    let filters = this.search_form.querySelectorAll('[data-filter]');
    let select_filters = this.search_form.querySelectorAll('[data-filter-select]');
    let reset = this.search_form.querySelector('[data-reset-form]');

    reset.addEventListener('click', (e) => {
      e.preventDefault();
      this.resetForm();
    });

    filters.forEach((filter) => {
      filter.addEventListener('click', (e) => {
        this.sendForm();
      });
    });

    select_filters.forEach((filter) => {
      filter.addEventListener('change', (e) => {
        e.preventDefault();
        this.sendForm();
      });
    });


    this.search_form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.sendForm();
    });


    this.multipleSelectClicker();
  }

  multipleSelectClicker() {
    const modelSelect = document.querySelector('.select-js .control');
    const modelSelectButton = document.querySelector('.select-js .control .button');


    if (!modelSelect || !modelSelectButton) {
      return;
    }


    modelSelect.addEventListener('click', (e) => {
      if (e.target === modelSelect) {
        modelSelectButton.click();
      }
    });
  }

  updateTitle() {
    if (!this.search_form) {
      return;
    }

    const hasPretty = !!this.search_form.querySelector('input[name="pretty"]');

    this.current_model = document.querySelector('[data-select-model]');
    let modelNames = '';

    if (this.current_model && this.current_model.selectedOptions) {
      const selectedOptions = Array.from(this.current_model.selectedOptions);
      modelNames = selectedOptions.map(option => option.innerText).join(', ');
    }

    const modelTitleEl = document.querySelector('[data-model-search-title]');
    const typeTitleEl = document.querySelector('[data-type-search-title]');

    // Additionally detect current body (nadwozie) and fuel (rodzaj_paliwa)
    const bodySelect = this.search_form.querySelector('select[name="nadwozie"]');
    const fuelSelect = this.search_form.querySelector('select[name="rodzaj_paliwa"]');

    const bodyLabel = (bodySelect && bodySelect.value) ? (bodySelect.options[bodySelect.selectedIndex]?.text || '') : '';
    const fuelLabel = (fuelSelect && fuelSelect.value) ? (fuelSelect.options[fuelSelect.selectedIndex]?.text || '') : '';

    // Compute main title with priority: model > nadwozie > naped
    let finalMainTitle = '';
    if (modelNames) {
      finalMainTitle = 'Škoda ' + modelNames.replace('<br>', '');
    } else if (bodyLabel) {
      finalMainTitle = 'Nadwozie ' + bodyLabel;
    } else if (fuelLabel) {
      // In the original PHP we show only the label for fuel (no prefix)
      finalMainTitle = fuelLabel;
    }

    if (modelTitleEl) {
      if (finalMainTitle) {
        modelTitleEl.innerHTML = finalMainTitle;
      } else if (hasPretty) {
        // Keep the initial title derived from pretty URL (/model|nadwozie|naped/{slug})
        modelTitleEl.innerHTML = this.initialModelTitle;
      } else {
        modelTitleEl.innerText = '';
      }
    }

    // Type title
    const typeInputChecked = document.querySelector('input[name="typ"]:checked');
    if (typeInputChecked) {
      const currentType = typeInputChecked.dataset.taxonomyTyp || '';
      if (typeTitleEl) {
        if (modelNames) {
          typeTitleEl.innerText = currentType ? (currentType + ',') : '';
        } else {
          typeTitleEl.innerText = currentType || '';
        }
      }
    } else {
      if (typeTitleEl) {
        if (hasPretty) {
          typeTitleEl.innerText = this.initialTypeTitle;
        } else {
          typeTitleEl.innerText = '';
        }
      }
    }
  }


  getPage() {
    const page_input = document.querySelector('input[name="strona"]:checked');

    if (page_input) {
      this.current_page = page_input.value;
    } else {
      this.current_page = false;
    }
  }

  runPagination() {
    let pagination_inputs = document.querySelectorAll('input[name="strona"]');

    console.log(pagination_inputs);

    pagination_inputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        e.preventDefault();
        this.sendForm();
      });
    });

  }

  appendModelsAsCSV(ajax_form_data) {
    const selectedModels = ajax_form_data.getAll('model');
    ajax_form_data.delete('model');
    ajax_form_data.append('model', selectedModels.join(','));
    return ajax_form_data;
  }

  sendForm(scroll = true) {
    let ajax_form_data = new FormData(this.search_form);
    ajax_form_data = this.appendModelsAsCSV(ajax_form_data);
    ajax_form_data.append('action', 'searchCars');

    this.getPage();
    if (this.current_page) {
      ajax_form_data.append('current_page', this.current_page);
    }

    this.updateTitle();
    let that = this;
    this.toggleLoader();

    if (scroll && this.search_form) {
      this.search_form.scrollIntoView({ behavior: 'smooth' });
    }

    let temp_form_data = ajax_form_data;
    const searchParams = new URLSearchParams(temp_form_data);
    searchParams.delete('action');
    searchParams.delete('search-security');
    searchParams.delete('_wp_http_referer');

    let urlParams = searchParams;
    // remove page_id from url
    urlParams.delete('page_id');

    // Keep pretty URL (no query params) when initial request had a path-based filter (model or nadwozie)
    if (ajax_form_data.has('pretty')) {
      // Do not alter the URL at all to preserve /auta-dostepne-od-reki/{slug}
      // Optionally we could keep other non-index-critical params off the URL as well
    } else {
      window.history.replaceState({}, '', '?' + urlParams.toString());
    }

    axios.post(ajax_object.ajax_url, ajax_form_data)
      .then(function(response) {
        let html = response.data;
        document.querySelector('[data-search-car-results]').innerHTML = '';
        document.querySelector('[data-search-car-results]').innerHTML = response.data;
        that.lazy.update();
        that.runPagination();
        that.toggleLoader();
        that.compare_cars.updateButtons();

      })
      .catch(error => {
        console.log(error.response.data.error);
        document.querySelector('[data-search-car-results]').innerHTML = 'Wystąpił błąd...';
      });

  }


}
